import {useAuthContext, useClient} from '../context/auth-context';
import {useQuery} from 'react-query';

export function useUnits() {
  const api = useClient();
  const {companyId} = useAuthContext();
  return useQuery<{id: string; name: string}[]>('units', () =>
    api
      .get(`attendance/company/${companyId}/organization/info`)
      .then(d => d.data),
  );
}

const base = {
  useUnits,
};

export default base;
